///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promos = abcsetup.promos || {};
abcsetup.promos.vendor_edit = abcsetup.promos.vendor_edit || {};

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////

abcsetup.promos.vendor_edit.itemTimeout = null;
abcsetup.promos.vendor_edit.items = [];
abcsetup.promos.vendor_edit.promo_attributes = {};
abcsetup.promos.vendor_edit.total_items = 0;
///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.promos.vendor_edit = {
    promo_type: null,

    init: function() {

        this.promo_type = JSON.parse($('#promo_type').text());

        if (this.promo_type.is_gnp_type) {
            abcsetup.promos.gnp.common.init();
            return true;
        }
        abcsetup.setTitle('Edit Promotion');
        this.total_items = 0;
        // Set the global item var
        abcsetup.item = JSON.parse($('form.manage-promotions #item_object').val());
        this.promo_attributes =  {
            promo :  {
                type: (abcsetup.item.promo) ? abcsetup.item.promo.type : (abcsetup.item.type ? abcsetup.item.type : ''),
                max_items : (abcsetup.item.promo) ? abcsetup.item.promo.max_items : (abcsetup.item.max_items ? abcsetup.item.max_items : 0),

            },
        }
        var editable_status = ["vendor_in_process","cm_rejected",'reject_approved']

        abcsetup.promos.form_manager.form = $('form.manage-promotions');
        var is_able_to_edit = !abcsetup.item.promo_attr[0] || !abcsetup.item.promo_attr[0].review_status || (abcsetup.item.promo_attr[0] && editable_status.includes(abcsetup.item.promo_attr[0].review_status));

        if (is_able_to_edit) {
            abcsetup.promos.form_manager.setFormItems();
        } else {
            abcsetup.promos.form_manager.setFormItems(true);
        }

        $(function() {
            // Disable buttons if vemdr
            if (!is_able_to_edit) {
                $('.btn').attr('disabled',true)
                $('btn-remove-item').attr('disabled',true)
            }
        });

        // Init Promo Items
        this._initPromoItems();

        // Show the add item modal
        $(document).on('click','#add_items', function() {
            abcsetup.promos.vendor_edit.addItem();
        })

        // Item modal field(s) changed
        $('#item-modal input, #item-modal select').bind('change keyup', function() {
            clearTimeout(abcsetup.promos.vendor_edit.itemTimeout);

            abcsetup.promos.vendor_edit.itemTimeout = setTimeout(function() {
                abcsetup.promos.vendor_edit.findItems();
            }, 500);
        });

        $(function(){
            if($('#add_items').is(':visible')) {
                // Show the Promo Item table
                $('.row.promo_items').show();
            }
        })

        $(document).on('click',".btn.btn-approve",function(){
            let type = (abcsetup.item.promo) ? abcsetup.item.promo.type : (abcsetup.item.type ? abcsetup.item.type : '');
            if (type == 'ccp') {
                if (abcsetup.promos.vendor_edit.total_items == 0 && $("input[name='competitive_product_upcs[]']").length == 0) {
                    abcsetup.alerts.show('Please add Items or Competitive Products', 'Please add Items by clicking on the +Add Items or add Competitive Products.');
                    return false;
                }
            }
        });

        // Relink button clicked
        $(document).on('click', '.btn.btn-link', function (e) {
            abcsetup.promos.vendor_edit.linkItem($(this).data('id'));
            $(this).addClass("btn-danger").attr('disabled', true);
        });


        // Remove item button clicked
        $(document).on('click', '.btn.btn-remove-item', function (e) {
            $(this).closest('tr').fadeOut('slow', function() {
                $(this).remove();
                abcsetup.promos.vendor_edit.total_items--;
            });
        });

        $(document).on('keyup',"input.competitive_product_upcs",function(){
            if ($(this).val().length == 12) {
                // A complete 12 digit UPC has been entered
                // Are there any existing UPC fields that are empty?
                var duplicates = 0;
                var filled_duplicates = 0;
                $('input.competitive_product_upcs').each(function(){
                    duplicates++
                    if($(this).val() != "")
                        filled_duplicates++;
                });

                // If they're all filled add another
                // Max 20 UPCs
                if (duplicates == filled_duplicates && !$('#competitive_product_upcs_'+duplicates).length && filled_duplicates<20) {
                    var field = abcsetup.promos.form_manager.form.find(':input[id="competitive_product_upcs_0"]');
                    var field_row = field.closest('.form-group.row').clone();
                    field_row.removeAttr('requiredIf');
                    field_row.removeAttr('required').removeClass('required');
                    field_row.find('label').attr('for','competitive_product_upcs_'+duplicates).html('--- '+(duplicates+1)+' ---');
                    field_row.find('input').attr('id','competitive_product_upcs_'+duplicates).val('').removeAttr('required').removeClass('invalid');
                    field_row.find('.errorMsg').remove();
                    console.log('last_dup->',$('#competitive_product_upcs_'+duplicates));
                    $('#competitive_product_upcs_'+(duplicates-1)).closest('.form-group.row').after(field_row);
                }
            }
        });

        $(document).on('change',"#smarttip_link_file",function(){
            promoId = $(".uploader-container").data("id");
            if ($(this).val() == 'Y') {
                $("#smarttip_image__promo" + promoId + "__").removeClass('btn-optional');
                $("#smarttip_image__promo" + promoId + "__").addClass('btn-danger');
                $('[data-idx="smarttip_image__promo'+promoId+'__"]').attr("required","true");
            }
            else {
                $("#smarttip_image__promo" + promoId + "__").addClass('btn-optional');
                $("#smarttip_image__promo" + promoId + "__").removeClass('btn-danger');
                $('[data-idx="smarttip_image__promo'+promoId+'__"]').removeAttr('required');
            }
        });

        $("#smarttip_link_file").trigger("change");

    },

    // Just the Promo Level attachments need to be 'AutoSaved'
    // PromoItem and PageBLocks have a Save button
    uploadDone: function() {
        // Save the Attachment to the Promotion
        var attachments_form = $('<form class="attachments"></form>');
        attachments_form.append('<input type="hidden" class="tmp-action" name="form_action" value="save_attachments">');
        attachments_form.append($('input[name="promo_attachments[]"]').clone());

        axios.post('/promo/' + abcsetup.item.id + '/vendor_update', attachments_form.serialize()).then(response => {
            console.log("Promo Attacments Updated");
        });
    },

    /**
     *
     */
    uploadDoneAfterAutoAppend: function() {
        if (!this.promo_type.is_gnp_type) {
            abcsetup.promos.items.manage_items.uploadDone();
        }
    },

    /**
     *
     */
    attachmentRemoved: function () {
        if (!this.promo_type.is_gnp_type) {
            abcsetup.promos.items.manage_items.uploadDone();
        }
    },

    /**
     * fieldError callback from _jquery.fieldValidate
     */
    fieldError: function() {

        if (this.promo_type.is_gnp_type) {
            var errorField = $('form').find('.invalid').first();
            abcsetup.unblockUI();
        } else {
            var errorField = $('form.manage-promotions').find('.invalid').first();

            // Focus on the tab where the error occurred
            var tab = errorField.closest('div.tab-pane');
            if (!tab.hasClass('active')){
                $('div.tab-pane').removeClass('active').removeClass('show');
                $("li.nav-item > a").removeClass('active').removeClass('show');
                tab.addClass('active').addClass('show')
                $("li.nav-item #"+tab.attr('id')+"-tab").addClass('active').addClass('show');
                errorField.trigger('focus');
            }
        }
    },

    /**
     * Show the add item modal
     */
    addItem: function() {
        // abcsetup.promos.vendor_edit.promo_item_id = 0;
        $('#item-modal .modal-title').html('Search and Add Items to this Promotion');
        $('#item-modal input, #item-modal select').val('');
        $('#item-modal').find('#results').html('');

        $('#item-modal').modal('show');
    },

    /**
     *
     */
    findItems: function() {
        var identifier = $('#item-modal').find('#identifier').val();
        var mfr_prod_code = $('#item-modal').find('#mfr_prod_code').val();
        var mat_descr = $('#item-modal').find('#mat_descr').val();
        var category = $('#item-modal').find('#category').val();

        // No search params are specified
        if (identifier == '' && mfr_prod_code == '' && mat_descr == '' && category == '') {
            $('#item-modal').find('#results').data('searchString', '').html('');
            return false;
        }

        // Come up with a unique search string to prevent duplicate search
        var searchString = identifier + mfr_prod_code + mat_descr + category;
        if ($('#item-modal').find('#results').data('searchString') == searchString) {
            return false;
        }

        // Remember the unique search string
        $('#item-modal').find('#results').data('searchString', searchString);

        // Block the UI with a spinner
        abcsetup.blockUI(true);
        abcsetup.promos.vendor_edit.items = [];
        axios.get('/api/promoitem/search?identifier=' + identifier + '&mfr_prod_code=' + mfr_prod_code + '&mat_descr=' + mat_descr + '&category=' + category).then(response => {
            abcsetup.unblockUI();
            abcsetup.promos.vendor_edit.items[this.id] = this;
            var html = '<div class="col-12">\
                            <table id="results-table" class="table table-striped table-sm table-bordered table-hover">\
                                <thead>\
                                    <tr>\
                                        <th></th>\
                                        <th></th>\
                                        <th>SAP #</th>\
                                        <th>UPC</th>\
                                        <th>COR 6-Digit Item #</th>\
                                        <th>Mfg. Part Number</th>\
                                        <th>Description</th>\
                                        <th>Category</th>\
                                        <th>Mat. Status</th>\
                                        <th>In Planogram</th>\
                                        <th>Predom. Planogram</th>\
                                        <th>Sales Dollars</th>\
                                        <th>Sales Units</th>\
                                        <th>Indep. Sales Dollars</th>\
                                        <th>Indep. Sales Units</th>\
                                        <th>TPR Sales Dollars</th>\
                                        <th>TPR Sales Units</th>\
                                        <th>#TPR Stores</th>\
                                    </tr>\
                                </thead>';

            $(response.data).each(function() {
                var row_class = '';
                var button = '<button type="button" class="btn btn-primary btn-link btn-sm" data-id="' + this.id + '">Add</button>';
                var promo_count = this.item_promo_count_next_year ? '<span class="promo_item_promos" data-item-id="'+this.id+'" title="Currently in ' + this.item_promo_count_next_year + ' promotions">'+this.item_promo_count_next_year+'</span>' : '';
                abcsetup.promos.vendor_edit.items[this.id] = this;

                if (this.mat_status == null || this.mat_status=="DM" || this.mat_status=="DB") {
                    button = '<button type="button" class="btn btn-primary btn-sm" disabled="disabled" title="Item Discontinued/Disabled">Add</button>';
                }
                html = html + '<tr class="' + row_class + '">\
                                    <td nowrap>' + button + '</td>\
                                    <td nowrap>' + promo_count + '</td>\
                                    <td>' + this.sap_num + '</td>\
                                    <td>' + ((this.upc11 != null) ? this.upc11 : '') + '</td>\
                                    <td>' + ((this.abc_6_digit != null) ? this.abc_6_digit : '') + '</td>\
                                    <td>' + ((this.mfr_prod_code != null) ? this.mfr_prod_code : '') + '</td>\
                                    <td>' + ((this.mat_descr != null) ? this.mat_descr : '') + '</td>\
                                    <td>' + ((this.a_b_c_fineline != null) ? this.a_b_c_fineline.category_name : '') + '</td>\
                                    <td>' + ((this.mat_status != null) ? this.mat_status : '') + '</td>\
                                    <td>' + ((this.planogram != null) ? this.planogram : '') + '</td>\
                                    <td>' + ((this.pog_predom != null) ? this.pog_predom : '') + '</td>\
                                    <td>' + ((this.annual_sales_dollars != null) ? this.annual_sales_dollars : '') + '</td>\
                                    <td>' + ((this.annual_sales_units != null) ? this.annual_sales_units : '') + '</td>\
                                    <td>' + ((this.independent_sales_dollars != null) ? this.independent_sales_dollars : '') + '</td>\
                                    <td>' + ((this.independent_sales_units != null) ? this.independent_sales_units : '') + '</td>\
                                    <td>' + ((this.tpr_sales_dollars != null) ? this.tpr_sales_dollars : '') + '</td>\
                                    <td>' + ((this.tpr_sales_units != null) ? this.tpr_sales_units : '') + '</td>\
                                    <td>' + ((this.num_tpr_stores_selling != null) ? this.num_tpr_stores_selling : '') + '</td>\
                                </tr>';
            });

            if (!response.data.length) {
                html = html + '<tr><td colspan="18" width="100%">No data found</td></tr>';
            }

            html = html + '</table></div>';
            $('#item-modal').find('#results').html(html);

            // Init results datatable
            abcsetup.datatables.client_side.init($('#results-table'), {
                'dom': 'x',
                'iDisplayLength': -1,
                'order': [[2, 'asc']],
                'responsive': false,
            });

            // Apply the highlighting
            var body = $('#item-modal').find('#results tbody');
            body.unhighlight();

            category = category ? $('#item-modal').find('#category option:selected').text() : '';
            body.highlight([identifier, mfr_prod_code, mat_descr, category]);
        });
    },
    /**
     * Add or re-link item
     */
    linkItem: function(id) {

        // Check if the item already exists in the display item list
        if ($('.item_id[value="' + abcsetup.promos.vendor_edit.items[id].id + '"]').length > 0) {
            abcsetup.alerts.show('Item already exists', 'This item is already part of this Promotion');
            return false;
        }


        if (this.promo_attributes.promo.type == 'ccp') {
            if ( abcsetup.promos.vendor_edit.total_items >= this.promo_attributes.promo.max_items) {
                abcsetup.alerts.show('Too Many Items added', 'You can only add '+this.promo_attributes.promo.max_items+' items to this promotion.');
                return false;
            }
        }

        abcsetup.promos.vendor_edit.appendItem(id);
    },
    /**
     * Add a new item at the end of the promo_item table
     */
    appendItem: function(id) {
        var item_id = $('table.promo_items_table tr').length * -1

        // Update the rows HTML
        var html = '';
        html = '<tr class="promo_item">';
        html = html + '<input type="hidden" id="item_id_'+id+'" name="promo_item[]" class="item_id" value="'+id+'">';
        html = html + '<td><button type="button" class="btn btn-sm btn-danger tooltips btn-remove-item" title="Remove Item"><i class="fas fa-trash"></i></button></td>';
        html = html + '<td>' + abcsetup.promos.vendor_edit.items[id].sap_num + '</td>';
        html = html + '<td>' + abcsetup.promos.vendor_edit.items[id].upc11 + '</td>';
        html = html + '<td>' + abcsetup.promos.vendor_edit.items[id].mfr_prod_code + '</td>';
        html = html + '<td>' + abcsetup.promos.vendor_edit.items[id].id +'</td>';
        html = html + '<td>' + abcsetup.promos.vendor_edit.items[id].a_b_c_fineline.category_name + '</td>';
        html = html + '<td>' + abcsetup.promos.vendor_edit.items[id].mat_descr + '</td>';

        if (abcsetup.promos.vendor_edit.promo_type.id == 'bgp'){
            // Add the status column
            html = html + '<td>Vendor in-process</td>';
        }

        html = html + '</tr>';

        // Append the new row
        $('#promo_items_table').append(html);
        abcsetup.promos.vendor_edit.total_items++

        return item_id;
    },
    /**
     * Init the PromoItems
     */
    _initPromoItems: function() {
        if (abcsetup.item.promo_items && abcsetup.item.promo_items.length) {
            $(abcsetup.item.promo_items).each(function() {
                var html = '';
                html = '<tr class="promo_item">';
                html = html + '<input type="hidden" id="item_id_'+this.a_b_c_item.id+'" name="promo_item[]" class="item_id" value="'+this.a_b_c_item.id+'">';
                html = html + '<td><button type="button" class="btn btn-sm btn-danger tooltips btn-remove-item" title="Remove Item"><i class="fas fa-trash"></i></button></td>';
                html = html + '<td>' + this.a_b_c_item.sap_num + '</td>';
                html = html + '<td>' + (this.a_b_c_item.upc11 || '') + '</td>';
                html = html + '<td>' + this.abc_item + '</td>';
                html = html + '<td>' + this.a_b_c_item.mfr_prod_code + '</td>';
                html = html + '<td>' + this.a_b_c_item.category_name + '</td>';
                html = html + '<td>' + this.a_b_c_item.mat_descr + '</td>';
                if (abcsetup.promos.vendor_edit.promo_type.id == 'bgp'){
                    // Add the status column
                    html = html + '<td>' + this.promo_item_status.name + '</td>';
                }
                html = html + '</tr>';

                // Append the new row
                $('#promo_items_table').append(html);
                abcsetup.promos.vendor_edit.total_items++;
            });
        }
    },
}